import React, { useEffect, useState } from 'react';
import { SubHeader } from '../../../utils/componentes-utiles/SubHeader';
import { CircularProgress, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Checkbox, Paper, Grid, Typography } from '@mui/material';
import { getRolesYDepartamentos } from '../../../services/apis';
import { PermisosOpciones } from './PermisosOpciones';

export const RolesYDepartamentos = () => {
    const [opciones, setOpciones] = useState([]);
    const [loaded, setLoaded] = useState(false);
    const [roles, setRoles] = useState([]);

    const cargarOpciones = async () => {

        try {
            const response = await getRolesYDepartamentos();
            setOpciones(response.data.opciones);
            setRoles(response.data.roles);
            setLoaded(true);
        } catch (error) {
            console.error('Error al cargar las opciones:', error);
        }
    };

    useEffect(() => {
        cargarOpciones();
    }, []);



    return (
        <Grid container justifyContent={'center'} xs={12}>
            <SubHeader />
            <Typography variant='h4'>Roles y Departamentos</Typography>

            {!loaded && <CircularProgress />}
            {loaded && (
                <>
                    {opciones.map(opcion => (
                        <>
                            <PermisosOpciones roles={roles} opciones={opcion.opciones} title={opcion.nombre} nombreArray={opcion.url} />
                        </>
                    ))}
                </>
            )}
        </Grid>
    );
};
